import React, { useState, useEffect, useContext } from 'react';
import SimpleTable from '../../../components/tables/simpleTable';
import TrashModal from '../../../components/modals/trashModal';
import RecoverModal from '../../../components/modals/recoverModal';
import AddModal from '../../../components/modals/addModal';
import EditModal from '../../../components/modals/editModal';
import SearchFilter from '../../../components/filters/search';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import Loader from '../../../components/loader/loader';
import { Col, Form, Row } from 'react-bootstrap';
import { DataContext } from '../../../init/getData';
import { Modal, Button, Tree } from 'antd';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { isAuxFormatter, natureFormatter } from '../../../components/formatters/defFormatter';
import { DownOutlined } from '@ant-design/icons';
import { FaLanguage } from 'react-icons/fa';
import { selectStyles } from '../../../components/dropDown/selectStyle';
import DatePicker from '../../../components/filters/datePicker';



import { numberFormatter, trailBalanceFormatter } from '../../../components/formatters/numberFormatter';



function TreeBalance(props) {

  let { } = props;


  const { userData, settingData, serverApi, api, companyId, yearId, selectedYear, secondaryCurrency, mainCurrency } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);

  const [treeData, setTreeData] = useState([]);


  const fromDate = selectedYear?.year + '-01-01';
  const toDate = selectedYear?.year+ '-12-31';

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [language, setLanguage] = useState({ value: 'english', label: 'english' });
  const [currency, setCurrency] = useState('main');

  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: fromDate, toDate: toDate, parentId: null });

  const table = 'chart';
  const title = 'Account';


  const languageOptions = [
    { value: 'english', label: 'english' },
    { value: 'arabic', label: 'arabic' },
    { value: 'french', label: 'french' },
  ]


  useEffect(() => {
    fetchData();
  }, [filter]);


  // Get Invoice
  const fetchData = async () => {

    try {
      const data = {
        filter
      }
      const response = await api.get(`/trialBalance/getAll`, { params: data });
      if (response) {
        const data = response?.data?.data;
        setTreeData(data);
        setIsLoading(false)
      }
    } catch (error) {
    }
  };


  const isMainCurrency = currency == 'main' ? true : false;

  function buildTree(data) {
    const tree = [];
    const map = new Map();

    // Create a map of all items by id
    data?.forEach((item) => {
      map.set(item.id, {
        ...item,
        title: (
          <>

            <strong>{item.accountId}</strong>



            <span style={{ color: item.isAux ? 'green' : 'black' }}>
              {'. ' + item[language.value]}
            </span>


            <span>
              {' (' + numberFormatter(isMainCurrency ? item.balance : item.secondaryBalance) + ')'}
            </span>


          </>
        ),
        key: item.id.toString(),
        children: []
      });
    });

    // Populate the tree structure
    data?.forEach((item) => {
      if (item.parentId === null) {
        tree.push(map.get(item.id));
      } else if (map.has(item.parentId)) {
        map.get(item.parentId).children.push(map.get(item.id));
      }
    });

    return tree;
  }

  const chartTreeData = buildTree(treeData);

  const onSelect = (selectedKeys, info) => {
    console.log('selected', selectedKeys, info);
  };

  const changeCurrency = (e) => {
    const value = e.target.value;
    setFilter((prevFilter) => ({
      ...prevFilter,
      currency: value,
    }));
  }



  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <Row className='g-1 mb-3'>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={languageOptions}
                isSearchable={true}
                placeholder="Select"
                onChange={setLanguage}
                value={language}
              />
            </Col>

            <Col md={4}>
              <DatePicker setFilter={setFilter} filter={filter} />
            </Col>

            <Col md={1}>
              <Form.Select size="sm" onChange={e => setCurrency(e.target.value)} value={currency}>
                <option value={'main'}>{mainCurrency.code}</option>
                <option value={'secondary'}>{secondaryCurrency.code}</option>
              </Form.Select>
            </Col>


            <Col md={3}>
            </Col>


            <Col md={2} className="d-flex justify-content-end">
              <Button >
                <FiPrinter size={18} />
              </Button>
              <Button >
                <FiRotateCcw size={18} onClick={fetchData} />
              </Button>
            </Col>
          </Row>


          <Row className='g-0 mb-3'>
            <Tree
              showLine
              switcherIcon={<DownOutlined />}
              defaultExpandedKeys={['0-0-0']}
              onSelect={onSelect}
              treeData={chartTreeData}
            />
          </Row>

        </>
      }

    </div>
  )
}

export default TreeBalance;
